module.exports = __webpack_public_path__ + "assets/img/Type E (83).abbd2a06.jpg";